<template>
  <SetPassForm
    :can-see-hint="true"
    confirm-trigger-label="Set password and login"
    :is-loading="isLoading"
    :on-submit="setPassword"
  />
</template>

<script>
  import SetPassForm from '../../components/forms/auth/SetPass';

  export default {
    components: {
      SetPassForm,
    },
    data() {
      return {
        isLoading: false,
        langBoxPos: {
          top: 10,
          right: 10,
        },
      };
    },
    methods: {
      setPassword(password) {
        const { token } = this.$route.params;
        const { email } = this.$store.getters['auth/user'];

        const query = {
          token,
          email,
          password,
        };

        this.isLoading = true;
        this.$store
          .dispatch('auth/setPass', query)
          .then((res) => {
            this.isLoading = false;
            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
    },
  };
</script>
